import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { useContext, useRef, useEffect, useState } from "react";
import { AppContext } from "../Context";

function Preloader({ fadeOut }) {
    const { dispatch } = useContext(AppContext);
    const pload = useRef(null);
    const [loaded, setLoaded] = useState(0);
    useEffect(() => {
        const loader = new GLTFLoader();
        loader.load(
            process.env.PUBLIC_URL + "/models/Shirt.glb",
            (gltf) => { },
            (xhr) => {
                let l = xhr.loaded / 7580152;
                setLoaded(l);
                if (l == 1) {
                    dispatch({ type: "SET_MODEL_LOADED", payload: true });
                }
            },
            (err) => console.error(err)
        );
    }, []);

    useEffect(() => {
        if (fadeOut) {
            setTimeout(() => {
                pload.current.style.opacity = 0;
                setTimeout(() => {
                    pload.current.style.display = "none";
                }, 500);
            }, 500);
        }
    }, [fadeOut])

    return (
        <div ref={pload} className="preloader">
            <div className="preloaderBox">
                <div className="logoBox">
                    <img className="preloaderLogo" src={process.env.PUBLIC_URL + "/images/logo.svg"} />
                </div>
                <div className="barBox">
                    <div className="bar" style={{ transform: `translate(-50%, -50%) scale(${loaded})` }} />
                </div>
                <div className="percent">
                    {Math.round(loaded * 100) + "% Loaded"}
                </div>
            </div>
        </div>
    );
}
export default Preloader;
